import { useEffect } from 'react';

export function useStructuredData(schema) {
  useEffect(() => {
    let scriptEl = document.querySelector('script[type="application/ld+json"]');

    if (scriptEl) {
      scriptEl.textContent = JSON.stringify(schema);
    } else {
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.textContent = JSON.stringify(schema);
      document.head.appendChild(scriptEl);
    }

    return () => {
      if (scriptEl && scriptEl.parentNode) {
        scriptEl.parentNode.removeChild(scriptEl);
      }
    };
  }, [schema]);
}

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Kodefactor',
  url: 'https://kodefactor.io',
  logo: 'https://kodefactor.io/logo.png',
  description: 'Expert IT consulting, cloud migration, cybersecurity, DevOps, and AI engineering for businesses ready to scale.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Baner',
    addressLocality: 'Pune',
    addressRegion: 'India',
    postalCode: '411 045',
    addressCountry: 'IN',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Customer Service',
    telephone: '+1-213-579-0442',
    email: 'info@kodefactor.io',
  },
  sameAs: [
    'https://www.linkedin.com/company/kodefactorconsulting',
  ],
};
